import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import Card, { CardContent, CardHeader } from '@cobliteam/ui/components/Card';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import photoBannerImage from '../../assets/photo-banner.png';

interface DriverFaceIdEmptyBannerProps {
  onLinkPhotosClick: () => void;
  disabled?: boolean;
  title?: string;
  subtitle?: string;
  helper?: string;
}

export const DriverFaceIdEmptyBanner = ({ onLinkPhotosClick, disabled, title, subtitle, helper }: DriverFaceIdEmptyBannerProps) => {
  const { t } = useTranslation('drivers');
  const resolvedTitle = title ?? t('face_id.drawer.empty.title');
  const resolvedSubtitle = subtitle ?? t('face_id.drawer.empty.subtitle');
  const resolvedHelper = helper ?? t('face_id.drawer.empty.helper');

  return (
    <Card>
      <CardHeader className='p-0'>
        <img src={photoBannerImage} alt='' className='h-auto w-full rounded-t-lg object-cover' />
      </CardHeader>
      <CardContent className='flex flex-col gap-4'>
        <div className='flex flex-col gap-1'>
          <Typography variant='text-md-semibold'>{resolvedTitle}</Typography>
          {resolvedSubtitle && (
            <Typography variant='text-md' color='secondary'>
              {resolvedSubtitle}
            </Typography>
          )}
        </div>
        <div className='flex items-center gap-4'>
          <Tooltip enable={disabled} content={t('face_id.permission.missing')}>
            <Button type='button' onClick={onLinkPhotosClick} disabled={disabled} startIcon={<Icon name='plus' />}>
              {t('face_id.drawer.empty.cta')}
            </Button>
          </Tooltip>
          {resolvedHelper && <Typography variant='text-sm'>{resolvedHelper}</Typography>}
        </div>
      </CardContent>
    </Card>
  );
};

export default DriverFaceIdEmptyBanner;
